import { useState } from "react";
import { useSelector } from "react-redux";
import Blockly from "blockly";
import { RootState } from "app/store";
import { btnDelay } from "common/utils";
import { IconPlayerPlay } from "common/assets";
import { CameraIcon } from "features/creator/property/components";
import { useBlocklyInit } from "./initialCamera";

export const BlocklyWorkspaceCamera = ({
  gameStart,
  scale,
  stage,
  step,
  topOffset,
  commandPanelHeight,
  workspace,
  setWorkspace,
  setEvent,
}: {
  gameStart: boolean;
  scale: number;
  stage: number;
  step: number;
  topOffset: number;
  commandPanelHeight: number;
  workspace: Blockly.WorkspaceSvg;
  setWorkspace: (workspace: any) => void;
  setEvent: (code: string) => void;
}) => {
  const BLOCK_LIMITS_WIDTH = 20;
  const [ocr, setOcr] = useState(false);
  const [open, setOpen] = useState(false);
  const [track, setTrack] = useState(false);
  const config = useSelector((state: RootState) => state.config.userConfig);

  useBlocklyInit(scale, config.locale, workspace, setWorkspace);

  const handleCamera = () => {
    btnDelay(() => setOpen(true));
  };

  const handleCameraOcr = () => {
    btnDelay(() => setOcr(true));
  };

  const handleCameraTrack = () => {
    btnDelay(() => setTrack(true));
  };

  return (
    <div className="flex-col-view !flex-1 w-full h-full">
      <div className="flex-col-el flex-center h-full gap-20 absolute">
        <div
          className={`flex-col-el flex-center upsilon px-5 pointer-events-auto ${
            gameStart ? "z-50" : "z-0"
          }`}
        >
          <button className="btn btn-blue" onClick={handleCamera}>
            <div className="flex-col-el flex-center">
              <CameraIcon width={36} height={36} />
            </div>
          </button>
        </div>

        <div
          className={`flex-col-el flex-center upsilon px-5 pointer-events-auto ${
            gameStart ? "z-50" : "z-0"
          }`}
        >
          <button className="btn btn-blue" onClick={handleCameraOcr}>
            <div className="flex-col-el flex-center">
              <CameraIcon width={36} height={36} />
            </div>
          </button>
        </div>

        <div
          className={`flex-col-el flex-center upsilon px-5 pointer-events-auto ${
            gameStart ? "z-50" : "z-0"
          }`}
        >
          <button className="btn btn-blue" onClick={handleCameraTrack}>
            <div className="flex-col-el flex-center w-[36px] h-[36px]">
              <IconPlayerPlay />
            </div>
          </button>
        </div>
      </div>

      <div className="flex-row-center !items-start !flex-1 w-full">
        <div
          className="flex-col-view h-full"
          style={{ width: BLOCK_LIMITS_WIDTH * scale }}
        />
        <div id="blocklyDiv" className="flex-col-view !flex-1 w-full h-full" />
      </div>
    </div>
  );
};
